import { Redirect, Route, Switch } from "react-router";
import SettingsPage from "modules/settings/SettingsPage";
import { EventContainer } from "modules/eventLanding";
import PrivateRoute from "modules/auth/authNavigation/PrivateRoute";
import HomePage from "modules/app/HomePage";
import { MyEventsPage } from "modules/event/components";
import { PageNotFound } from "modules/app/pages/PageNotFound";
import MicCamCheckContainer from "modules/micCamCheck/MicCamCheckContainer";
import EventInviteAuthenticator from "modules/eventInvite/EventInviteAuthenticator";
import BackdoorView from "modules/eventInvite/BackdoorView";
import PasswordChange from "modules/auth/passwordChange/PasswordChange";
import EventLandingPage from "modules/eventLanding/EventLandingPage";
import { OnboardingPage } from "modules/onboarding/OnboardingPage";
import ManageEventPage from "modules/manageEvent/components/ManageEventPage/ManageEventPage";
import { SelectCompanyPage } from "modules/company/components/SelectCompanyPage";
import { SignInContainer } from "modules/auth/signIn/SignInContainer";
import ForgetPasswordContainer from "modules/auth/forgetPassword/ForgetPasswordContainer";
import { SignUpContainer } from "modules/auth/signUp/SignUpContainer";
import { GearTestPage } from "modules/app/pages/Geartest";
import CheckEmailToLogin from "modules/auth/signIn/CheckEmailToLogin";
import MagicLinkCallback from "modules/auth/signIn/MagicLinkCallback";
import { SOCIAL_PROVIDERS } from "modules/auth/constants";
import Callback from "modules/auth/components/Callback";
import TemporaryUsernamePasswordSignIn from "modules/auth/components/TemporaryUsernamePasswordSignIn";
import {
  GetStartedPage,
  BackgroundCreateCompanyPage,
} from "modules/onboarding";
import { SettingsPages } from "modules/settings/constants/SettingsPages";
import { EDCOAuthCallback } from "modules/auth/signIn/EDCOAuthCallback";
import { EDCLoginError } from "modules/app/pages/EDCLoginError";
import AuthenticatedRoute from "./AuthenticatedRoute";

const MainNavigation = () => (
  <Switch>
    <Route exact path="/geartest" component={GearTestPage} />
    <AuthenticatedRoute UnauthenticatedPage={SignInContainer} path="/signin" />
    <AuthenticatedRoute UnauthenticatedPage={SignUpContainer} path="/signup" />
    <Route component={SignUpContainer} path="/start-free-trial" />
    <Route component={SignUpContainer} path="/appsumo/signup" />
    <AuthenticatedRoute
      UnauthenticatedPage={ForgetPasswordContainer}
      path="/forget-password"
    />
    <AuthenticatedRoute
      UnauthenticatedPage={CheckEmailToLogin}
      path="/check-email-to-login"
    />
    <AuthenticatedRoute
      UnauthenticatedPage={MagicLinkCallback}
      path="/login/callback"
    />
    <AuthenticatedRoute
      UnauthenticatedPage={EDCOAuthCallback}
      path="/edc-oauth-callback"
    />
    <AuthenticatedRoute
      UnauthenticatedPage={TemporaryUsernamePasswordSignIn}
      path="/temporary-sign-in"
    />

    {/** Event view page urls */}
    <Route exact path="/e/:token" component={EventContainer} />
    {/** event view page reloading //TODO candidate for removal, revisit route logic */}
    <Route
      exact
      path="/e/:token/event/:pageId?/:eventId?"
      component={EventContainer}
    />
    {/** Support old event view urls for a while - redirect to new url */}
    <Route
      exact
      path="/ev/:eventCode"
      render={(props) => <Redirect to={`/e/${props.match.params.eventCode}`} />}
    />
    <PrivateRoute
      exact
      authURL="/signin"
      path="/c/:companyCode/member-invite/:token"
      component={EventContainer}
    />
    {/** Landing page */}
    <Route
      exact
      path="/e/:eventCode/(register|sso)"
      component={EventLandingPage}
    />
    <PrivateRoute
      exact
      authURL="/signin"
      path="/event-invite/:eventCode"
      component={BackdoorView}
    />
    <Route exact path="/reset-password" component={PasswordChange} />
    <Route exact path="/s/:inviteCode" component={EventInviteAuthenticator} />
    <Route exact path="/a/:inviteCode" component={EventInviteAuthenticator} />
    <Route exact path="/h/:inviteCode" component={EventInviteAuthenticator} />
    <PrivateRoute
      exact
      authURL="/signin"
      path="/c/:companyCode/speaker-invite/:token"
      component={EventInviteAuthenticator}
    />
    <PrivateRoute exact authURL="/signin" path="/home" component={HomePage} />
    <PrivateRoute
      exact
      authURL="/signin"
      path="/my-events"
      component={MyEventsPage}
    />
    <PrivateRoute
      exact
      authURL="/signin"
      path="/account-settings/:pageId?"
      component={SettingsPage}
    />
    <PrivateRoute
      exact
      authURL="/signup"
      path="/select-company"
      component={SelectCompanyPage}
    />
    <PrivateRoute
      exact
      authURL="/signin"
      path="/mic-cam-check"
      component={MicCamCheckContainer}
    />
    <PrivateRoute
      exact
      authURL="/signin"
      path="/onboarding"
      component={OnboardingPage}
    />
    <PrivateRoute
      exact
      authURL="/signin"
      path="/event/:pageId?/:eventId?"
      component={ManageEventPage}
    />
    <PrivateRoute
      exact
      authURL="/signin"
      path="/get-started"
      component={GetStartedPage}
    />
    <PrivateRoute
      exact
      authURL="/signin"
      path="/create-company"
      component={BackgroundCreateCompanyPage}
    />

    <Route exact path="/custom-floor-plan-validator">
      <Redirect to={`/account-settings/${SettingsPages.customFloorPlans}`} />
    </Route>

    <Route exact path="/">
      <Redirect to="/home" />
    </Route>

    <Route
      exact
      path={`/:providerName(${SOCIAL_PROVIDERS.join("|")})/callback`}
      component={Callback}
    />

    <Route path="/404" component={PageNotFound} />
    <Route path="/edc-login-error" component={EDCLoginError} />
    <Redirect to="/404" />
  </Switch>
);

export default MainNavigation;
